import React from 'react';

import { DateInput } from 'cpool-components/input/DateInput';
import type { FieldValues } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';

import { FormField } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormField';
import { useApplicantInfoContext } from '~/features/leadDetails/context/ApplicantInfoContext.tsx';

type Props = {
    title: string;
    name: string;
    disabled?: boolean;
};

const TitleDateInput: React.FC<Props> = ({ disabled, name, title }) => {
    const { control } = useFormContext();
    const { applicantId } = useApplicantInfoContext();

    return (
        <FormField<FieldValues, Date | null> control={control} name={name}>
            {({ error, onChange, value }) => (
                <DateInput
                    id={`${name}-${applicantId}`}
                    label={title}
                    labelClassName="h-8 w-[175px] shrink-0 justify-start"
                    value={value}
                    onChange={onChange}
                    showDropdowns
                    disabled={disabled}
                    error={error}
                />
            )}
        </FormField>
    );
};

export default TitleDateInput;
